import { render, staticRenderFns } from "./contentFiled.vue?vue&type=template&id=18cb2b22&"
import script from "./contentFiled.vue?vue&type=script&lang=js&"
export * from "./contentFiled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports